import KickbiteResource from '@/resources/KickbiteResource';

export default class Kickbite {
    constructor() {
        this.Resource = new KickbiteResource()
    }

    async connect (websiteId, appId, marketId) {
        return await this.Resource.connect(websiteId, appId, marketId)
    }

    async updateConnection (websiteId, appId, marketId) {
        return await this.Resource.updateConnection(websiteId, appId, marketId)
    }
}
